module.exports = __webpack_public_path__ + "img/springroll_fold_3.05ff8ca2.jpg";